import styled, { css } from 'styled-components';
import { maxWidth } from '@/assets/styles/mixins.css';
import vars from '@/assets/styles/vars';

const Gallery = styled.div`
  ${(props) =>
    !props.modal &&
    css`
      ${Gallery.Thumbs} {
        display: none;
      }
    `}

  ${(props) =>
    props.modal &&
    css`
      display: flex;
      flex-direction: column;
      justify-content: center;

      ${Gallery.Main} {
        position: static;
        .swiper-container {
          position: static;
        }

        .swiper-slide {
          opacity: 1 !important;
        }
        .swiper-slide:not(.swiper-slide-active){ 
          opacity: 0 !important; 
        }


        .swiper-button-next,
        .swiper-button-prev {
          display: none;
        }

        .swiper-pagination-progressbar {
          top: auto;
          bottom: 0;
        }
      }

      ${maxWidth(vars.breakpoints.tablet - 1)`
        min-height: 100%;
      `}
    `}
`;

Gallery.Inner = styled.div`
  position: relative;
`;

Gallery.Thumbs = styled.div`
  position: relative;
  width: 100%;
  padding: 32px;
  user-select: none;
  overflow: hidden;
  --swiper-button-bg: #fff;

  .swiper-container {
    width: 100%;
  }

  .swiper-button-next,
  .swiper-button-prev {
    top: 50%;
    color: var(--color-extra);
    transform: translateY(-50%);
    box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.12);
    transition: opacity 0.3s ease, color 0.3s ease;

    &:hover:not(.swiper-button-disabled) {
      color: var(--color-decor);
      opacity: 1;
    }
  }

  .swiper-button-next {
    right: 16px;
  }

  .swiper-button-prev {
    right: auto;
    left: 16px;
  }

  ${maxWidth(vars.breakpoints.tablet - 1)`
    .swiper-container {
      overflow: visible;
    }

    .swiper-button-next,
    .swiper-button-prev {
      display: none;
    }
  `}

  ${maxWidth(vars.breakpoints.mobile)`
    padding: 20px;
  `}

  ${(props) =>
    props.locked &&
    css`
      .swiper-button-next,
      .swiper-button-prev {
        display: none;
      }
    `}
`;

Gallery.Thumb = styled.div`
  position: relative;
  width: 102px;
  height: auto;
  margin-right: 7px;
  cursor: pointer;
  overflow: hidden;
  transition: opacity 0.35s ease-out;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: auto;
    padding-top: 50%;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    display: block;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.4;
    transition: opacity 0.25s ease-in;
  }

  & img {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &:hover {
    opacity: ${(props) => !props.active && '0.9'};
  }

  ${(props) =>
    props.active &&
    css`
      &::before {
        opacity: 0;
      }
    `}

  ${maxWidth(vars.breakpoints.lMobile)`
    margin-right: 3px;
  `}

  ${maxWidth(vars.breakpoints.mobile)`
    width: 50px;
  `}

  &:last-child {
    margin-right: 0;
  }
`;

Gallery.Main = styled.div`
  --swiper-button-width: 48px;
  --swiper-button-top: calc(100% - var(--swiper-button-width) - 36px);
  position: relative;
  width: 100%;
  user-select: none;

  ${maxWidth(vars.breakpoints.tablet)`
    --swiper-button-top: calc(100% - var(--swiper-button-width) - 28px);
  `}

  ${maxWidth(vars.breakpoints.tablet - 1)`
    --swiper-button-top: 0;
    --swiper-button-next-right: 0;
    --swiper-button-prev-right: calc(100% - var(--swiper-button-width));
    --swiper-button-width: 80px;
    --swiper-button-height: 100%;

    & > .swiper-container.swiper-container--light {
      --swiper-button-bg: linear-gradient(270deg, rgba(16, 14, 30, 0) 0%, rgba(16, 14, 30, 0.25) 100%);

      .swiper-button-next, .swiper-button-prev {
        border-radius: 0;
      }

      .swiper-button-next {
        --swiper-button-bg: linear-gradient(270deg, rgba(16, 14, 30, 0.25) 0%, rgba(16, 14, 30, 0) 100%);
      }
    }
  `}

  ${maxWidth(vars.breakpoints.lMobile)`
    --swiper-button-width: 48px;
  `}
`;

Gallery.Img = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;

  &::after {
    content: '';
    display: inline-block;
    vertical-align: top;
    width: 0;
    height: auto;
    padding-top: 50%;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

Gallery.ModalTrigger = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  font-size: 0px;
  opacity: 0;
  width: 100%;
  height: 100%;
  transition: 0.3s ease-out;
  cursor: pointer;

  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    background-color: rgba(0, 0, 0, 0.5);
    transition: 0.3s ease-out;
  }

  &::after {
    content: '';
    display: block;
    width: 67px;
    height: 67px;
    border-radius:50%;
    position: absolute;
    top: 50%;
    left: 50%;
    opacity: 0;
    transform: translate(-50%, -50%);
    background-color: rgba(217, 217, 217, 0.2);
    background-image: url("data:image/svg+xml,%3Csvg width='23' height='23' viewBox='0 0 23 23' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1.61426 11.4702C1.61426 6.20811 5.87999 1.94238 11.142 1.94238C16.4041 1.94238 20.6698 6.20811 20.6698 11.4702C20.6698 16.7322 16.4041 20.9979 11.142 20.9979C5.87999 20.9979 1.61426 16.7322 1.61426 11.4702ZM11.142 0.942383C5.3277 0.942383 0.614258 5.65583 0.614258 11.4702C0.614258 17.2845 5.3277 21.9979 11.142 21.9979C13.8817 21.9979 16.3769 20.9515 18.2498 19.2365C18.2741 19.2921 18.309 19.3442 18.3545 19.3897L21.1693 22.2045C21.3645 22.3998 21.6811 22.3998 21.8764 22.2045C22.0716 22.0092 22.0716 21.6927 21.8764 21.4974L19.0616 18.6826C19.0161 18.6371 18.964 18.6022 18.9084 18.5779C20.6234 16.705 21.6698 14.2098 21.6698 11.4702C21.6698 5.65583 16.9564 0.942383 11.142 0.942383Z' fill='white' /%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position:center;
    background-size:auto;
    transition: 0.3s ease-out;
  }

  &:hover,
  &:hover::before,
  &:hover::after{
    opacity: 1;
  }
`;

export default Gallery;
